import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../app.service';
import { ComponentColumn, ComponentTableInspectionViewModel, CurrentSelection, DashBoardShovelShowHideColumnsName, EquipmentForecastDataVM, EquipmentShovelData, equipmentVwMdl, SearchItem, UserSelectedIds } from '../../../../../app/entities';
import { BehaviorSubject, Observable } from 'rxjs';
import { ComponentViewTableDatabase, ComponentViewTableDataSource, EqTableDatabase } from '../component-view/component-view.component';
import { DashboardService } from '../../dashboard.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ShovelViewColumnSortpopupComponent } from './shovel-view-column-sortpopup/shovel-view-column-sortpopup.component';
import { CryptoService } from '../../../../../app/services/crypto.service';
import { DataSource } from '@angular/cdk/table';
import { Subscription, ISubscription } from 'rxjs/Subscription';
import { ShovelGraphComponent } from '../../../../../app/modules/manage-equipment/shovel-graph/shovel-graph.component';
export interface ShovelColumnGroup {
  id: string;
  title: string;
  columnIds: string[];
}
export enum TableView {
  EquipmentView = 0,
  ComponentView = 1,
  WearRatesView = 2,
  ShovelsView = 3,
}

export enum SearchMode {
  Single = 0,
  Multiple = 1
}
@Component({
  selector: 'app-shovel-view',
  templateUrl: './shovel-view.component.html',
  styleUrls: ['./shovel-view.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ShovelViewComponent implements OnInit {
  _currentSelection: CurrentSelection = new CurrentSelection();
  visibleComponentColumns: ComponentColumn[] = [];
  _currentSearchItemSelection: SearchItem[] = [];
  enableTab: boolean = false;
  selectionSubscription: Subscription;
  _loading = 0;
  selectionSearchItemsSubscription: Subscription;
  loadSize: number = 100;
  _searchMode: SearchMode = SearchMode.Single;
  equipmentViewListBySearchItemsSubscription?: Subscription;
  getEquipmentListByConditionSubscription?: Subscription;
  getEquipmentCountByConditionSubscription?: Subscription;
  _tableView: TableView = TableView.ShovelsView;
  _equipmentRequestToken = 0;
  _currentSort: Sort = { active: 'lastInspectionDate', direction: 'desc' };
  _isLoading: boolean = false;
  EquipmentShovelData: EquipmentShovelData[] = [];
  EquipmentForecastDataVM: EquipmentForecastDataVM;
  DashBoardShovelShowHideColumnsName: DashBoardShovelShowHideColumnsName[] = [];
  showColumnPanel = false;
  dataSource: EqTableDataSource | null;
  routeSubscription?: ISubscription;
  componentViewListBySearchItemsSubscription: Subscription;
  componentViewDatabase: ComponentViewTableDatabase | null;
  componentViewDataSource: ComponentViewTableDataSource | null;
  equipmentComponentViewList: ComponentTableInspectionViewModel[] = [];
  getExportClickedSubscription: Subscription;
  @ViewChild('componentPaginator') componentPaginator: MatPaginator;
  @ViewChild('topScroll') topScroll!: ElementRef<HTMLDivElement>;
  @ViewChild('tableWrapper') tableWrapper!: ElementRef<HTMLDivElement>;
  @ViewChild('shovelTable') shovelTable!: ElementRef<HTMLTableElement>;
  tableScrollWidth = 0;

  private isSyncingScroll = false;
  constructor(private zone: NgZone, private _crypto: CryptoService, private cd: ChangeDetectorRef,
    private dialog: MatDialog, private _appService: AppService, private _moduleService: DashboardService, private ref: ChangeDetectorRef, private _router: Router,) { }

  ngOnInit(): void {
    this._appService.setPageTitle('Dashboard | Shovel Overview');
    this._currentSelection = this._appService.getLastSelection();
    this._currentSearchItemSelection = this._appService.getLastSelectionSearchItems();
    this.enableTab = this._appService.getEnableSearch()
    this.selectionSubscription = this._appService.getSelection().subscribe(message => setTimeout(() => { this.selectionChangedDetected(message); }, 10));
    this.selectionSearchItemsSubscription = this._appService.getSelectionSearchItems().subscribe(message => setTimeout(() => { this.selectionSearchItemChangedDetected(message); }, 10));

    this.getExportClickedSubscription = this._moduleService.getExportClicked().subscribe(item => {
      if (item === 1) // 1 means export PDF, at the moment there is only one export option
      {
       // this._moduleService.SaveSearchItemsComponentViewForExport(this.loadingPage, this.loadSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction).subscribe(searchId => { this.printBySearchId(searchId); }, error => console.error(error), () => { });
      }
     else if (item === 2) {
    this.retrieveShovelForReporting();
}
    }, error => console.error(error), () => { });
    // this.GetShovelData(1, this.loadSize);
    // this.refreshVisibleColumns();
  }

  ngAfterViewInit() {
    this.eqTableDatabase = new EqTableDatabase(this.equipmentList);
    this.dataSource = new EqTableDataSource(this.eqTableDatabase, this.paginator);
    this.componentViewDatabase = new ComponentViewTableDatabase(this.equipmentComponentViewList);
    this.componentViewDataSource = new ComponentViewTableDataSource(this.componentViewDatabase, this.componentPaginator);
    this.toggleView(TableView.ShovelsView);
    setTimeout(() => {
      this.updateTableScrollWidth();
    }, 100);
  }

retrieveShovelForReporting(): void {

    // this._isLoading = true;
    // this.cd.markForCheck();

    const requestToken = ++this._equipmentRequestToken;

    this._moduleService
        .getDashboardShovelView(
            0,
            0,
            this._currentSearchItemSelection,
            requestToken,
            this._currentSort.active,
            this._currentSort.direction
        )
        .subscribe({

            next: (res: EquipmentForecastDataVM) => {

                if (requestToken !== this._equipmentRequestToken) {
                    console.error('Export operation cancelled.');
                    return;
                }

                const exportData: EquipmentShovelData[] =
                    res?.Data ?? [];

                if (exportData.length === 0) {
                    console.warn('No shovel data available for export.');
                    return;
                }

                // Use the same column configuration
                this.DashBoardShovelShowHideColumnsName =
                    res.Columns ?? [];

                this.DashBoardShovelShowHideColumnsName.forEach(col => {
                    if (col.Checked == null) {
                        col.Checked = true;
                    }
                });

                // Prepare formatted values
                this.prepareDisplayData(exportData);

                // Determine visible components
                this.updateVisibleComponents(exportData);

                // Download CSV
                this.downloadFile(exportData);
            },

            error: error => {

                console.error(
                    'Error while retrieving shovel export data',
                    error
                );

                this._isLoading = false;
                this.cd.markForCheck();
            },

            complete: () => {

                this._isLoading = false;
                this.cd.markForCheck();
            }
        });
}

  toggleView(event: any) {
    // if (event === this._tableView)
    //   return;
    this._tableView = event;

    if (this._tableView === TableView.EquipmentView) {
      this._componentRequestToken = 0;
      this._equipmentRequestToken = 0;
      this._wearRatesRequestToken = 0;
      this.retrieveEquipmentsBySearchItems(1, this.loadSize);
    } else if (this._tableView === TableView.ComponentView) {
      this._componentRequestToken = 0;
      this._equipmentRequestToken = 0;
      this._wearRatesRequestToken = 0;
      this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
    }
    else if (this._tableView === TableView.WearRatesView) {
      this._componentRequestToken = 0;
      this._equipmentRequestToken = 0;
      this._wearRatesRequestToken = 0;
      this.retrieveEquipmentsComponentViewBySearchItems(this.loadingPage, this.loadSize);
    } else {
      this.GetShovelData(this.loadingPage, this.loadSize);
      this.refreshVisibleColumns();
    }
  }

  retrieveEquipmentsComponentViewBySearchItems(pageNo: number, pageSize: number) {
    this.loadingPage = pageNo;
    this.cancelSearch();
    this.equipmentComponentViewList = [];
    this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
    this._loading++;
    this.enableTab = this._appService.getEnableSearch()
    this._componentRequestToken++;
    this.componentViewListBySearchItemsSubscription = this._moduleService.getComponentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._componentRequestToken, this._currentSort.active, this._currentSort.direction)
      .subscribe(result => {
        if (result._clientReqId !== this._componentRequestToken) {
          console.error('Operation Cancelled!');
          return;
        }
        this._moduleService.sendExportStatus(2);
        // console.log('result.ResultList', result.ResultList);
        this.equipmentComponentViewList.push(...result.ResultList);
        this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        this.componentPaginator.length = result.SearchResult.Total;
        this.componentPaginator.pageIndex = pageNo - 1;
        this.componentPaginator.pageSize = pageSize;
        this.loadSize = pageSize;
        this.ref.detectChanges();
        this.equipmentDataLoading = false;
        this._moduleService.getRecommendedActions(result.ResultList.map(m => m.Id)).subscribe(res => {
          ['fleet-condition-widget', 'inspections-performed-widget', 'cost-of-repairs-monthly-widget', 'components-on-eval-widget', 'app-inspections-due-widget'].forEach(m => {
            this._appService.sendWidgetTrigger(m);
          });
          this.equipmentComponentViewList.forEach(m => {
            const filtered = res.find(k => k.EquipmentId === m.Equipment.Id);
            if (filtered) {
              m.LastInspection.RecommendedActions = filtered.RecommendedActions;
              m.Components.forEach(k => {
                k.Actions = filtered.CompletedActions.filter(p => p.ComponentId === k.Id);
              });
            }
            //AES256
            if (m?.LastInspection.Inspector && m?.LastInspection.Inspector.length > 0) {
              m.LastInspection.Inspector = this._crypto.decrypt(m.LastInspection.Inspector);
            }
          });
          this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        }, error => console.error(error), () => { });
      }, error => { console.log(error); this.equipmentDataLoading = false; this._loading--; }, () => { this._loading--; this.equipmentDataLoading = false; });
  }

ngOnDestroy() {

    if (this.routeSubscription != null) {
        this.routeSubscription.unsubscribe();
    }

    if (this.getExportClickedSubscription != null) {
        this.getExportClickedSubscription.unsubscribe();
    }

    this.subscriptions.forEach(subscription => {
        if (!subscription.closed) {
            subscription.unsubscribe();
        }
    });
}
  selectionChangedDetected(current: CurrentSelection) {
    if (this._loading !== 0) {
      return;
    }
    this._currentSelection = current;
    this._searchMode = SearchMode.Single;
    this.retrieveEquipmentsByCondition(1, this.loadSize);
  }
  equipmentList: equipmentVwMdl[] = [];
  eqTableDatabase: EqTableDatabase | null;
  @ViewChild('paginator') paginator: MatPaginator;
  retrieveEquipmentsByCondition(pageNo: number, pageSize: number) {
    const userSelectedParam = new UserSelectedIds();
    this.equipmentList = [];
    this.eqTableDatabase.dataChange.next(this.equipmentList);
    userSelectedParam.CustomerId = this._currentSelection.customer.Id;
    userSelectedParam.JobSiteId = this._currentSelection.jobSite.Id;
    userSelectedParam.EquipmentId = this._currentSelection.equipment.Id;
    userSelectedParam.MakeId = this._currentSelection.make.Id;
    userSelectedParam.FamilyId = this._currentSelection.family.Id;
    userSelectedParam.ModelId = this._currentSelection.model.Id;
    this._loading++;
    this._moduleService.getEquipmentCountByCondition(userSelectedParam).subscribe(counts => {
      this._loading++;
      this._moduleService.getEquipmentListByCondition(pageNo, pageSize, userSelectedParam).subscribe(result => {
        this.equipmentList.push(...result);
        this.eqTableDatabase.dataChange.next(this.equipmentList);
        this.paginator.length = counts;
        this.paginator.pageIndex = pageNo - 1;
        this.paginator.pageSize = pageSize;
        this.loadSize = pageSize;
        this.ref.detectChanges();
      }, error => { console.log(error); }, () => { this._loading--; });
    }, error => { console.log(error); }, () => { this._loading--; });
  }

  selectionSearchItemChangedDetected(current: SearchItem[]) {
    this.cancelSearch();
    this._router.navigate(['shovels', 1]);
    this._currentSearchItemSelection = current;
    this.enableTab = this._appService.getEnableSearch()
    this._searchMode = SearchMode.Multiple;
    if (this._tableView == TableView.EquipmentView)
      this.retrieveEquipmentsBySearchItems(1, this.loadSize);
    else
      this.GetShovelData(1, this.loadSize);

    this.refreshVisibleColumns();
  }
  loadingPage: number = 1;
  subscriptions: Subscription[] = [];
  equipmentDataLoading: boolean = false;
  Pagginatiorbar: boolean = false;
  _componentRequestToken = 0;
  _wearRatesRequestToken = 0;
  retrieveEquipmentsBySearchItems(pageNo: number, pageSize: number) {
    //pageNo = 1
    //pageSize =25

    this.loadingPage = pageNo;
    this.equipmentList = [];
    this.eqTableDatabase.dataChange.next(this.equipmentList);
    this._loading++;
    this.enableTab = this._appService.getEnableSearch()
    this._equipmentRequestToken++;
    this.subscriptions.push(this._moduleService.getEquipmentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction)
      .subscribe(result => {
        // console.error('Operarion Cancelled11111111!', result._clientReqId, this._equipmentRequestToken);

        if (result._clientReqId != this._equipmentRequestToken) {
          console.error('Operarion Cancelled!', this._equipmentRequestToken);
          return;
        }
        this._moduleService.sendExportStatus(1);
        this.equipmentList.push(...result.ResultList);
        //AES256
        this.equipmentList.forEach((insp: any) => {
          if (insp?.inspector && insp.inspector.length > 0) {
            insp.inspector = this._crypto.decrypt(insp.inspector);
          }
        });
        //console.log('this.equipmentList!', this.equipmentList);
        this.eqTableDatabase.dataChange.next(this.equipmentList);
        this.paginator.length = result.SearchResult.Total;
        this.paginator.pageIndex = pageNo - 1;
        this.paginator.pageSize = pageSize;
        //console.log('equipment paginator:', this.paginator);
        this.loadSize = pageSize;
        this.ref.detectChanges();
        this.equipmentDataLoading = false;
        this.Pagginatiorbar = true;
        ['fleet-condition-widget', 'inspections-performed-widget', 'cost-of-repairs-monthly-widget', 'components-on-eval-widget', 'app-inspections-due-widget'].forEach(m => {
          this._appService.sendWidgetTrigger(m);
        });
      }, error => { console.log(error); this._loading--; this.equipmentDataLoading = false; }, () => { this._loading--; this.equipmentDataLoading = false; }));
  }
  cancelSearch() {
    if (this.equipmentViewListBySearchItemsSubscription != null)
      this.equipmentViewListBySearchItemsSubscription.unsubscribe();
    if (this.getEquipmentListByConditionSubscription != null)
      this.getEquipmentListByConditionSubscription.unsubscribe();
    if (this.getEquipmentCountByConditionSubscription != null)
      this.getEquipmentCountByConditionSubscription.unsubscribe();
    this._loading = 0;
  }

  GetShovelData(pageNo: number, pageSize: number) {
    this.EquipmentShovelData = [];
    this.DashBoardShovelShowHideColumnsName = [];
    if (this._currentSearchItemSelection.length != 9) {
      this._isLoading = true;
      this.cd.markForCheck();
      this._moduleService.getDashboardShovelView(pageNo, pageSize, this._currentSearchItemSelection, this._equipmentRequestToken, this._currentSort.active, this._currentSort.direction)
        .subscribe({
          next: (res) => {
            this.EquipmentShovelData = res.Data;
            this.DashBoardShovelShowHideColumnsName = res.Columns;

            this.DashBoardShovelShowHideColumnsName.forEach(col => {
              if (col.Checked == null) {
                col.Checked = true;
              }
            });
            this.prepareDisplayData();
            this.updateVisibleComponents();

            setTimeout(() => {
              this.updateTableScrollWidth();
            });
          },
          error: () => {
            this._isLoading = false;
            this.cd.markForCheck();
          },
          complete: () => {
            this._isLoading = false;
            this.cd.markForCheck();
          }
        });
    }
  }

  // prepareDisplayData(): void {
  //   for (const equipment of this.EquipmentShovelData) {

  //     for (const component of equipment.Components) {

  //       component.DisplayValues = {

  //         Side: component.Side,
  //         CompartType: component.CompartType,
  //         Manufacturer: component.Manufacturer,
  //         Part: component.Part,
  //         Track_Budget_Life: this.formatNumber(component.Track_Budget_Life),
  //         InstallDate: this.formatDate(component.InstallDate),
  //         InstallSMU: this.formatNumber(component.InstallSMU),
  //         InstallPropelhours: this.formatNumber(component.InstallPropelhours),
  //         LastInspectionDate: this.formatDate(component.LastInspectionDate),

  //         LastInspectionSMU: this.formatNumber(component.LastInspSMU),

  //         LastInspectionPropelHours: this.formatNumber(component.LastInspPropelHour),

  //         LastInspectionPropelPercentage: component.LastInspPropelPer,

  //         MonthlyPropelPercentage: component.MonthlyPropelPercentage,
  //         AvgWornPercentage: component.AVGWornPercentage,

  //         Status: equipment.Status,

  //         StatusColor: equipment.StatusColor,

  //         CurrentCmu: this.formatNumber(component.CurrentCmu),

  //         CurrentPMU: this.formatNumber(component.CurrentPMU),

  //         ComponentPropelPercentage: component.ComponentPropelPercentage,
  //         ResidualMonthSMUBased: component.ResidualMonthSMUBased,

  //         EOLDateSMUDate: this.formatDate(component.EOLDateSMUDate),

  //         ResidualMonthBasedOnCondition: component.ResidualMonthBasedOnCondition,

  //         EOLMonthBasedOnCOndition: this.formatDate(component.EOLMonthBasedOnCOndition),

  //         HourAt100Percentage: this.formatNumber(component.HourAt100Percentage),

  //         HourAt120Percentage: this.formatNumber(component.HourAt120Percentage),

  //         ScheduleOutageDate: this.formatDate(component.ScheduleOutageDate),
  //         ForecastHourAtOutage: this.formatNumber(component.ForecastHourAtOutage),
  //         ForecastPercentageAtOutage: component.ForecastPercentageAtOutage,

  //         Notes: component.Notes
  //       };
  //     }

  //     equipment.RowSpan = equipment.Components.length;
  //   }
  // }
  prepareDisplayData( data: EquipmentShovelData[] = this.EquipmentShovelData): void {

    for (const equipment of data) {

        for (const component of equipment.Components) {

            component.DisplayValues = {
                Side: component.Side,
                CompartType: component.CompartType,
                Manufacturer: component.Manufacturer,
                Part: component.Part,
                Track_Budget_Life: this.formatNumber(component.Track_Budget_Life),
                InstallDate: this.formatDate(component.InstallDate),
                InstallSMU: this.formatNumber(component.InstallSMU),
                InstallPropelhours: this.formatNumber(component.InstallPropelhours),
                LastInspectionDate: this.formatDate(component.LastInspectionDate),
                LastInspectionSMU: this.formatNumber(component.LastInspSMU),
                LastInspectionPropelHours: this.formatNumber(component.LastInspPropelHour),
                LastInspectionPropelPercentage: component.LastInspPropelPer,
                MonthlyPropelPercentage: component.MonthlyPropelPercentage,
                AvgWornPercentage: component.AVGWornPercentage,
                Status: equipment.Status,
                StatusColor: equipment.StatusColor,
                CurrentCmu: this.formatNumber(component.CurrentCmu),
                CurrentPMU: this.formatNumber(component.CurrentPMU),
                ComponentPropelPercentage: component.ComponentPropelPercentage,
                ResidualMonthSMUBased: component.ResidualMonthSMUBased,
                EOLDateSMUDate: this.formatDate(component.EOLDateSMUDate),
                ResidualMonthBasedOnCondition: component.ResidualMonthBasedOnCondition,
                EOLMonthBasedOnCOndition: this.formatDate(component.EOLMonthBasedOnCOndition),
                HourAt100Percentage: this.formatNumber(component.HourAt100Percentage),
                HourAt120Percentage: this.formatNumber(component.HourAt120Percentage),
                ScheduleOutageDate: this.formatDate(component.ScheduleOutageDate),
                ForecastHourAtOutage: this.formatNumber(component.ForecastHourAtOutage),
                ForecastPercentageAtOutage: component.ForecastPercentageAtOutage,
                Notes: component.Notes
            };
        }

        equipment.RowSpan = equipment.Components.length;
    }
}
  formatNumber(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const number = Number(value);

    if (isNaN(number)) {
      return value;
    }

    return number.toLocaleString('en-US', {
      maximumFractionDigits: 2
    });
  }
  formatDate(value: any): string {
    if (!value)
      return '';
    const d = new Date(value);
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  formatMonth(value: any): string {
    if (!value)
      return '';

    const d = new Date(value);
    return d.toLocaleDateString('en-GB', {
      month: 'short',
      year: 'numeric'
    });
  }

  // updateVisibleComponents(): void {
  //   const visibleComponents = new Set<number>(
  //     this.DashBoardShovelShowHideColumnsName
  //       .filter(x => x.Checked)
  //       .map(x => Number(x.CompartTypeId))
  //   );
  //   for (const equipment of this.EquipmentShovelData) {
  //     equipment.VisibleComponents =
  //       equipment.Components.filter(x =>
  //         visibleComponents.has(Number(x.CompartType_Auto)));
  //   }
  // }
  updateVisibleComponents(data: EquipmentShovelData[] = this.EquipmentShovelData
): void {

    const visibleComponents = new Set<number>(
        this.DashBoardShovelShowHideColumnsName
            .filter(x => x.Checked)
            .map(x => Number(x.CompartTypeId))
    );

    for (const equipment of data) {

        equipment.VisibleComponents =
            equipment.Components.filter(x =>
                visibleComponents.has(
                    Number(x.CompartType_Auto)
                )
            );
    }
}

  trackByEquipment(index: number, item: EquipmentShovelData): number {
    return item.EquipmentId_Auto;
  }

  trackByComponent(index: number, item: any): number {
    return item.CompartType_Auto;
  }

  trackByColumn(index: number, item: ComponentColumn): string {
    return item.id;
  }

  onColumnChange(column: DashBoardShovelShowHideColumnsName): void {
    this.updateVisibleComponents();
  }

  isComponentVisible(compartTypeId: number): boolean {
    const column = this.DashBoardShovelShowHideColumnsName.find(
      x => Number(x.CompartTypeId) === Number(compartTypeId)
    );
    return column ? column.Checked : true;
  }
  componentColumns: ComponentColumn[] = [
    { id: 'Side', title: 'Side', order: 1, visible: true },
    { id: 'CompartType', title: 'Component', order: 2, visible: true },
    { id: 'Manufacturer', title: 'Manufacturer', order: 3, visible: true },
    { id: 'Part', title: 'Part', order: 4, visible: true },
    { id: 'Track_Budget_Life', title: 'Budget', order: 5, visible: true },
    { id: 'InstallDate', title: 'Date', order: 6, visible: true },
    { id: 'InstallSMU', title: 'SMU', order: 7, visible: true },
    { id: 'InstallPropelhours', title: 'Propel Hrs', order: 8, visible: true },
    { id: 'LastInspectionDate', title: 'Date', order: 9, visible: true },
    { id: 'LastInspectionSMU', title: 'SMU', order: 10, visible: true },
    { id: 'LastInspectionPropelHours', title: 'Propel Hrs', order: 11, visible: true },
    { id: 'LastInspectionPropelPercentage', title: 'Propel %', order: 12, visible: true },
    { id: 'MonthlyPropelPercentage', title: 'Monthly \nPropel %', order: 13, visible: true },
    { id: 'AvgWornPercentage', title: 'AVG Wear %', order: 14, visible: true },
    { id: 'Status', title: 'Status', order: 15, visible: true },
    { id: 'CurrentCmu', title: 'CMU', order: 16, visible: true },
    { id: 'CurrentPMU', title: 'PMU', order: 17, visible: true },
    { id: 'ComponentPropelPercentage', title: 'Propel %', order: 18, visible: true },
    { id: 'ResidualMonthSMUBased', title: 'Residual Months\n (SMU Base)', order: 19, visible: true },
    { id: 'EOLDateSMUDate', title: 'EOL Date\n (SMU Base)', order: 20, visible: true },
    { id: 'ResidualMonthBasedOnCondition', title: 'Residual Months\nCond. Based', order: 21, visible: true },
    { id: 'EOLMonthBasedOnCOndition', title: 'EOL Month \n Cond. Based', order: 22, visible: true },
    { id: 'HourAt100Percentage', title: 'Hrs At\n 100 % Worn', order: 23, visible: true },
    { id: 'HourAt120Percentage', title: 'Hrs At\n 120 % Worn', order: 24, visible: true },
    { id: 'ScheduleOutageDate', title: 'Date', order: 25, visible: true },
    { id: 'ForecastHourAtOutage', title: 'SMU', order: 26, visible: true },
    { id: 'ForecastPercentageAtOutage', title: 'AVG %Worn', order: 27, visible: true },
    { id: 'Notes', title: 'Notes', order: 28, visible: true }
  ];

  getTextColor(bgColor: string): string {
    if (!bgColor) {
      return '#000';
    }
    const hex = bgColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000' : '#fff';
  }

  navigateToEquipment(equipmentId: number): void {
    window.open('/equipment/' + equipmentId, '_blank');
  }

  private refreshVisibleColumns(): void {
    this.visibleComponentColumns = this.componentColumns
      .filter(x => x.visible)
      .sort((a, b) => a.order - b.order);
  }

  openColumnPopup(): void {
    this.dialog.open(ShovelViewColumnSortpopupComponent, {
      width: '600px',
      disableClose: true,
      data: {
        columns: this.componentColumns,
        onChanged: () => {
          this.refreshVisibleColumns();
          this.cd.detectChanges();
        }
      }
    });
  }

  openShovelPopup(equipmentId: number) {
    this.dialog.open(ShovelGraphComponent, {
      width: '90%',
      height: '95%',
      data: {
        equipmentId: equipmentId,
        IsPopup: true
      }
    });
  }

  columnGroups: ShovelColumnGroup[] = [
    {
      id: 'componentInfo',

      title: '',

      columnIds: [
        'Side',
        'CompartType',
        'Manufacturer',
        'Part',
        'Track_Budget_Life'
      ]
    },
    {
      id: 'install',

      title: 'Install',

      columnIds: [
        'InstallDate',
        'InstallSMU',
        'InstallPropelhours'
      ]
    },
    {
      id: 'lastInspection',

      title: 'Last Inspection',

      columnIds: [
        'LastInspectionDate',
        'LastInspectionSMU',
        'LastInspectionPropelHours',
        'LastInspectionPropelPercentage',
        'MonthlyPropelPercentage'
      ]
    },
    {
      id: 'componentCondition',

      title: 'Component',

      columnIds: [
        'AvgWornPercentage',
        'Status',
        'CurrentCmu',
        'CurrentPMU',
        'ComponentPropelPercentage'
      ]
    },
    {
      id: 'forecast',

      title: 'Forecast',

      columnIds: [
        'ResidualMonthSMUBased',
        'EOLDateSMUDate',
        'ResidualMonthBasedOnCondition',
        'EOLMonthBasedOnCOndition',
        'HourAt100Percentage',
        'HourAt120Percentage'
      ]
    },
    {
      id: 'scheduledOutage',

      title: 'Scheduled Outage',

      columnIds: [
        'ScheduleOutageDate',
        'ForecastHourAtOutage',
        'ForecastPercentageAtOutage'
      ]
    },
    {
      id: 'notes',

      title: 'Notes',

      columnIds: [
        'Notes'
      ]
    }
  ];
  getVisibleColumnsForGroup(group: ShovelColumnGroup): ComponentColumn[] {
    return this.visibleComponentColumns.filter(
      column => group.columnIds.includes(column.id)
    );
  }
  getGroupColspan(group: ShovelColumnGroup): number {
    return this.getVisibleColumnsForGroup(group).length;
  }
  isGroupVisible(group: ShovelColumnGroup): boolean {
    return this.getGroupColspan(group) > 0;
  }
  isFirstColumnOfGroup(group: ShovelColumnGroup, column: ComponentColumn): boolean {
    const visibleColumns = this.getVisibleColumnsForGroup(group);

    return visibleColumns.length > 0 && visibleColumns[0].id === column.id;
  }
  getColumnTitle(column: ComponentColumn): string {
    return column.title;
  }
  trackByGroup(index: number, group: ShovelColumnGroup): string {
    return group.id;
  }
  isFirstVisibleColumnOfGroup(column: ComponentColumn): boolean {
    const group = this.columnGroups.find(
      group => group.columnIds.includes(column.id)
    );

    if (!group) {
      return false;
    }

    const visibleColumns = this.getVisibleColumnsForGroup(group);

    return visibleColumns.length > 0 &&
      visibleColumns[0].id === column.id;
  }
  isLastVisibleColumnOfGroup(
    column: ComponentColumn
  ): boolean {

    const group = this.columnGroups.find(
      group => group.columnIds.includes(column.id)
    );

    if (!group) {
      return false;
    }

    const visibleColumns =
      this.getVisibleColumnsForGroup(group);

    if (!visibleColumns.length) {
      return false;
    }

    return visibleColumns[visibleColumns.length - 1].id === column.id;
  }

  isStickyColumn( column: ComponentColumn): boolean {
    return [
      'Side',
      'CompartType',
      'Manufacturer',
      'Part',
      'Track_Budget_Life'
    ].includes(column.id);
  }

  getColumnWidth(
    column: ComponentColumn
  ): number {

    switch (column.id) {

      case 'Side':
        return 60;

      case 'CompartType':
        return 100;

      case 'Manufacturer':
        return 120;

      case 'Part':
        return 140;

      case 'Track_Budget_Life':
        return 80;

      default:
        return 80;
    }
  }

  getStickyLeft(
    column: ComponentColumn
  ): number {
    let left = 430;

    const stickyColumnIds = [
      'Side',
      'CompartType',
      'Manufacturer',
      'Part',
      'Track_Budget_Life'
    ];

    const currentIndex =
      stickyColumnIds.indexOf(column.id);

    if (currentIndex === -1) {
      return 0;
    }
    for (let i = 0; i < currentIndex; i++) {

      const previousColumn =
        this.visibleComponentColumns.find(
          x =>
            x.id === stickyColumnIds[i]
        );

      if (previousColumn) {

        left += this.getColumnWidth(
          previousColumn
        );
      }
    }

    return left;
  }

  onTopScroll(): void {
    if (this.isSyncingScroll) {
      return;
    }
    this.isSyncingScroll = true;
    this.tableWrapper.nativeElement.scrollLeft = this.topScroll.nativeElement.scrollLeft;
    requestAnimationFrame(() => {
      this.isSyncingScroll = false;
    });
  }

  onTableScroll(): void {
    if (this.isSyncingScroll) {
      return;
    }

    this.isSyncingScroll = true;
    this.topScroll.nativeElement.scrollLeft = this.tableWrapper.nativeElement.scrollLeft;

    requestAnimationFrame(() => {
      this.isSyncingScroll = false;
    });
  }
  updateTableScrollWidth(): void {

    if (!this.shovelTable) {
      return;
    }

    const table = this.shovelTable.nativeElement;

    this.tableScrollWidth = table.scrollWidth;

    this.cd.detectChanges();
  }

  downloadFile(data: EquipmentShovelData[]): void {

  if (!data || data.length === 0) {
    return;
  }

  const _data: any[] = [];

  const visibleColumns = this.visibleComponentColumns
    .filter(x => x.visible)
    .sort((a, b) => a.order - b.order);

  data.forEach(equipment => {

    if (
      !equipment.VisibleComponents ||
      equipment.VisibleComponents.length === 0
    ) {
      return;
    }

    equipment.VisibleComponents.forEach(component => {

      const _o: any = {};
      _o["Customer"] = equipment.Customer ?? '';
      _o["Jobsite"] = equipment.Jobsite ?? '';
      _o["Unit"] = equipment.UnitNo ?? '';
      _o["Model"] = equipment.ModelDesc ?? '';

      visibleColumns.forEach(column => {

        const value =
          component.DisplayValues?.[column.id];

        const header =
          this.cleanCsvHeader(column.title);

        _o[header] =
          value === null || value === undefined
            ? ''
            : value;
      });

      _data.push(_o);
    });
  });

  if (_data.length === 0) {
    return;
  }
  const replacer = (key: string, value: any) =>
    value === null || value === undefined? '' : value;

  const header = Object.keys(_data[0]);

  const csv = _data.map(row => header.map(fieldName =>JSON.stringify(row[fieldName],replacer)).join(','));

  // Add header
  csv.unshift(header.join(','));

  const csvArray = csv.join('\r\n');

  const blob = new Blob(
    ['\uFEFF' + csvArray],
    {
      type: 'text/csv;charset=utf-8;'
    }
  );

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');

  a.href = url;
  a.download = `Shovel_Overview.csv`;

  document.body.appendChild(a);
  a.click();

  window.URL.revokeObjectURL(url);
  a.remove();
}
private cleanCsvHeader(title: string): string {

  if (!title) {
    return '';
  }

  return title
    .replace(/\r?\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
}
export class EqTableDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }
  customerId = 0;
  jobsiteId = 0;
  equipmentId = 0;
  familyId = 0;
  makeId = 0;
  modelId = 0;
  constructor(private _exampleDatabase: EqTableDatabase, private _paginator: MatPaginator) {
    super();
  }
  public selectionUpdated(customer: number, jobsite: number, equipment: number, family: number, make: number, model: number) {
    this.customerId = customer;
    this.jobsiteId = jobsite;
    this.equipmentId = equipment;
    this.familyId = family;
    this.makeId = make;
    this.modelId = model;
  }
 
  connect(): Observable<equipmentVwMdl[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._paginator.page,
      this._filterChange,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice().filter(
        (item: equipmentVwMdl) => {
          const searchSerial = (item.serial).toLowerCase();
          const searchUnit = (item.unit).toLowerCase();
          const searchCustomer = (item.customerName).toLowerCase();
          const searchMake = (item.make).toLowerCase();
          const searchModel = (item.model).toLowerCase();
          const searchFamily = (item.family).toLowerCase();
          if (this.customerId && item.customerId !== this.customerId)
            return false;
          if (this.jobsiteId && item.jobsiteId !== this.jobsiteId)
            return false;
          if (this.equipmentId && item.Id !== this.equipmentId)
            return false;
          if (this.familyId && item.familyId !== this.familyId)
            return false;
          if (this.makeId && item.makeId !== this.makeId)
            return false;
          if (this.modelId && item.modelId !== this.modelId)
            return false;
          return (searchSerial.indexOf(this.filter.toLowerCase()) !== -1
            || searchUnit.indexOf(this.filter.toLowerCase()) !== -1
            || searchCustomer.indexOf(this.filter.toLowerCase()) !== -1
            || searchMake.indexOf(this.filter.toLowerCase()) !== -1
            || searchModel.indexOf(this.filter.toLowerCase()) !== -1
            || searchFamily.indexOf(this.filter.toLowerCase()) !== -1
          );
        }
      );
      return data;
    });
  }

  disconnect() { }
}
